import React from 'react'
import Header2 from '../Header2';

const NotAuthorized = () => {
  return (
    <div>
        <Header2/>
        <h1 style={{textAlign:"center", marginTop:"50px"}}>You are not authorized to view this page.</h1>
      
    </div>
  )
}

export default NotAuthorized
